import I18n from 'I18n';
import { createSelector } from 'reselect';
import { createGenericOptionsSelector } from 'ContentData/helpers/reduxHelpers';
import { SUCCEEDED, FAILED } from 'ContentUtils/constants/RequestStatus';
import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
export const getWebInteractives = state => state.resources.webInteractives.webInteractives;
export const getWebInteractive = (state, props) => state.resources.webInteractives.webInteractives[props.id];
const getWebInteractivesCacheOrder = state => state.resources.webInteractives.webInteractivesCacheOrder;
export const getWebInteractiveCache = (state, props) => state.resources.webInteractives.webInteractivesCache[props.id];
export const getWebInteractivesCache = state => state.resources.webInteractives.webInteractivesCache;
export const getWebInteractiveFetchStatus = (state, props) => state.resources.webInteractives.requestStatus[props.id];
export const getIsWebInteractiveFetchDone = (state, props) => {
  if (!props.id) return true;
  const fetchStatus = getWebInteractiveFetchStatus(state, props);
  return fetchStatus === SUCCEEDED || fetchStatus === FAILED;
};
export const getWebInteractivesFetchStatus = state => state.resources.webInteractives.webInteractivesRequestStatus;
const disabledPredicate = webInteractive => webInteractive && webInteractive.isPublished && webInteractive.interactiveContainerType !== 'EMBEDDED';
const getHelpText = webInteractive => webInteractive && webInteractive.name;
export const getWebInteractiveOptions = createSelector([getWebInteractivesCache, getWebInteractivesCacheOrder], (webInteractivesCache, order) => order.reduce((hash, id) => {
  const webInteractive = webInteractivesCache[id];
  hash.push({
    value: id,
    text: webInteractive.name,
    help: I18n.text(`ContentComponents.cmv2.fields.url.linkType.help.CALL_TO_ACTION.${webInteractive.interactiveContainerType}`)
  });
  return hash;
}, []));
export const getDefaultWebInteractiveOptions = createGenericOptionsSelector(getWebInteractives, {
  disabledPredicate,
  getHelpText
});
const getWebInteractiveImageUrl = (contentId, isEmail = false) => {
  const portalId = PortalIdParser.get();
  const emailPath = isEmail ? 'email/' : '';
  return enviro.ifHublet({
    isNa1: () => {
      const baseNa1Url = getFullUrl('cta-service-cms2');
      return `${baseNa1Url}/web-interactives/public/v1/embed/cta-image/${emailPath}${contentId}?portalId=${portalId}`;
    },
    isNonNa1: () => {
      const baseNonNa1Url = getFullUrl('cta');
      return `${baseNonNa1Url}/web-interactives/public/v1/embed/cta-image/${emailPath}${contentId}?portalId=${portalId}`;
    }
  });
};
function mapWebInteractiveToLegacyFormat(webInteractive, isEmail) {
  return webInteractive && {
    name: webInteractive.name,
    guid: webInteractive.id.toString(),
    ctaInfo: [{
      isDefault: true,
      image: {
        url: getWebInteractiveImageUrl(webInteractive.id, isEmail)
      }
    }]
  };
}
export const getWebInteractiveInLegacyShape = (state, props) => {
  const webInteractive = getWebInteractive(state, props);
  return mapWebInteractiveToLegacyFormat(webInteractive, props.isInEmail);
};